import type { JSX, ReactNode } from 'react';
import { Briefcase, ShieldCheck } from 'lucide-react';
import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import type { WizardStepDefinition } from '../types/candidate-wizard.types';

interface CandidateWizardStepCardProps {
  step: WizardStepDefinition;
  children: ReactNode;
}

export function CandidateWizardStepCard({
  step,
  children,
}: CandidateWizardStepCardProps): JSX.Element {
  return (
    <Card role="region" aria-labelledby="wizard-step-title">
      <CardHeader className="space-y-2">
        <div className="flex flex-wrap items-start justify-between gap-2">
          <div className="flex items-center gap-2">
            <Briefcase className="h-5 w-5 text-muted-foreground" aria-hidden="true" />
            <h2 id="wizard-step-title" className="text-xl font-semibold tracking-tight">
              {step.title}
            </h2>
          </div>
          <span className="text-sm text-muted-foreground">{step.meta}</span>
        </div>
        <p className="text-sm text-muted-foreground">{step.guidance}</p>
      </CardHeader>
      <Separator />
      <CardContent className="pt-6">{children}</CardContent>
      <CardFooter className="justify-center gap-2 text-sm text-muted-foreground">
        <ShieldCheck className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="text-center">{step.shieldNote}</span>
      </CardFooter>
    </Card>
  );
}
